// initialization.service.ts

import { Injectable } from '@angular/core';
import { DalService } from '@upr-web-primer/dal';

@Injectable({
  providedIn: 'root',
})
export class InitializationService {
  constructor(private dalService: DalService) {}

  initializeApp(): Promise<any> {
    return this.dalService.setOidcAppToken();
  }
}
